import React from "react";

const PageTabsBottomSpacer: React.FC = () => {
	return (
		<div style={{height: 20}}>&nbsp;</div>
	);
};

export default PageTabsBottomSpacer
